import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface SavedLocation {
  id: string;
  label: string;
  floorNumber: string;
  doorNumber: string;
  buildingNumber: string;
  streetNumber: string;
  zoneNumber: string;
  area: string;
  notes?: string;
}

interface LocationStore {
  locations: SavedLocation[];
  addLocation: (location: Omit<SavedLocation, "id">) => void;
  updateLocation: (id: string, location: Omit<SavedLocation, "id">) => void;
  deleteLocation: (id: string) => void;
  getLocation: (id: string) => SavedLocation | undefined;
}

export const useLocationStore = create<LocationStore>()(
  persist(
    (set, get) => ({
      locations: [],

      addLocation: (location) => {
        const newLocation: SavedLocation = {
          ...location,
          id: `loc-${Date.now()}`,
        };
        set((state) => ({ locations: [...state.locations, newLocation] }));
      },

      updateLocation: (id, location) => {
        set((state) => ({
          locations: state.locations.map((l) =>
            l.id === id ? { ...location, id } : l,
          ),
        }));
      },

      deleteLocation: (id) => {
        set((state) => ({
          locations: state.locations.filter((l) => l.id !== id),
        }));
      },

      getLocation: (id) => {
        return get().locations.find((l) => l.id === id);
      },
    }),
    {
      name: "rush-saved-locations",
    },
  ),
);

// Helper to build location text from a SavedLocation
export const buildLocationText = (location: SavedLocation): string =>
  [
    location.floorNumber,
    location.doorNumber,
    location.buildingNumber,
    location.streetNumber,
    location.zoneNumber,
    location.area,
  ]
    .filter(Boolean)
    .join(", ");